import ImageCarousel from "../components/ImageCarousel";
import {useTranslation} from "react-i18next";
import {Box, Typography} from "@mui/material";
import logo from "../assets/images/home/logo.png";
import {carouselImages} from "../utils/carousel";

export default function Home() {
    const {t} = useTranslation();

    let mdLogoPixel= 230;
    let mdCarouselMarginTop = 4;
    if (window.innerHeight <= 800) {
        mdLogoPixel -= 65;
        mdCarouselMarginTop /= 2;
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            minHeight={{xs: "auto", md: "70vh"}}
            gap={{xs: 1, xl: 4}}
            maxWidth="100%"
        >
            {/* Logo */}
            <Box
                component="img"
                src={logo}
                alt="logo"
                sx={{
                    maxWidth: "80vw",
                    maxHeight: {xs: "150px", sm: "180px", md: mdLogoPixel, xl: "300px"},
                    objectFit: "contain",
                }}
            />

            {/* Caption */}
            <Typography
                variant="h5"
                sx={{
                    display: {xs: "none", xl: "flex"},
                    fontStyle: "italic",
                    fontWeight: 300,
                    letterSpacing: 1,
                    color: "text.secondary",
                    px: {xs: 2, md: 0},
                }}
            >
                {t("home.caption")}
            </Typography>
            <Typography
                variant="h6"
                sx={{
                    display: {xs: "flex", xl: "none"},
                    minHeight: `calc(1.6em * 3)`,
                    fontStyle: "italic",
                    fontWeight: 300,
                    letterSpacing: 1,
                    color: "text.secondary",
                    px: {xs: 2, md: 0},
                }}
            >
                {t("home.caption")}
            </Typography>

            {/* Carousel */}
            <Box sx={{width: "100%", mt: {xs: 2, md: mdCarouselMarginTop}}}>
                <ImageCarousel images={carouselImages}/>
            </Box>
        </Box>
    );
}

